"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

_core["default"].lang.fr = _core["default"].lang.fr || {};
_core["default"].lang.fr.confirm = {
  yes: 'Oui',
  cancel: 'Annuler',
  textConfirm: 'Voulez vous vraiment faire ça ?'
};